<template>
  <section>
    <BasicVideoPicsTextSwiper :title="title" :subtitle="subtitle" :imgs="imgs" id="10"></BasicVideoPicsTextSwiper>
  </section>
</template>
<script>
import BasicVideoPicsTextSwiper from '@/components/basic-videopicstext-swiper.vue'
export default {
  data() {
    return {
      title: '灵活便利，满载生活惊喜',
      subtitle:'即刻启动，让无限场景化创意带给您新的灵感',
      imgs: [
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blpc0120240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blmob0120240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '前排浪漫座椅',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blpc0220240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blmob0220240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '驾驶席零重力舒压座椅',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blpc0320240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blmob0320240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '后排座椅靠背最高33°可调',
          text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blpc0420240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blmob0420240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '后备厢多场景拓展桌',
          text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blpc0520240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blmob0520240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '后排折叠桌板（右侧）',
          text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blpc0620240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blmob0620240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '中央抽屉式冷暖保温箱（4L）',
          // text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blpc0720240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blmob0720240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '大容量前备箱 (67L)',
          // text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blpc0820240129.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blmob0820240130.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '后备厢可拆卸多功能挂钩',
          // text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blpc0920240131.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/bianli/blmob0920240131.png',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '车外 V2L 220V 电源输出(充电口)',
          // text: "车外 V2L 220V 电源输出（充电口）",
          type: 'img'
        }
        // {
        //   imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/swiper1/new/img7.png',
        //   imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/swiper1/new/img7.png',
        //   videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
        //   videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
        //   posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
        //   posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
        //   title: '可开启全景天窗',
        //   text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
        //   type: 'img'
        // }
      ],
    }
  },
  components: {
    BasicVideoPicsTextSwiper
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped></style>
